import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { FeedPost } from './types'

export const FEED_POSTS_QUERY: TypedDocumentNode<
  { feedPosts: FeedPost[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query FeedPosts($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    feedPosts(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id title content image image_low_res published_at created_at updated_at
    }
  }
`

export const FEED_POST_QUERY: TypedDocumentNode<{ feedPost: FeedPost | null }, { id: string }> =
  gql`
  query FeedPost($id: ID!) {
    feedPost(id: $id) {
      id client_id application_id title content image image_low_res published_at created_at updated_at
    }
  }
`
